import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

class SectionLandingAbout {
    constructor() {
        this.scrollStart = "center bottom"; // Renamed ScrollStart to scrollStart to follow JavaScript naming conventions
    }

    init() {
        // Listen for the resize event and handle it appropriately
        window.addEventListener("resize", () => {
            this.handleWindowResize();
        });

        // Check window width on load and initialize animation accordingly
        window.addEventListener("load", () => {
            this.handleWindowResize();
        });
    }

    // Method to handle window resize
    handleWindowResize() {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 992) {
            // For mobile screens
            this.scrollStart = "150 center"; // Adjust scroll position for mobile
            this.openDoorAnimation(this.scrollStart, false);
        } else {
            // For larger screens
            this.scrollStart = "center bottom"; // Reset scroll position for larger screens
            this.openDoorAnimation(this.scrollStart, true);
        }
    }

    // Animation method
    openDoorAnimation(startAnime, scrub) {
        const aboutSection = document.querySelector('.landing-about');
        const aboutDoor = aboutSection.querySelector('.landing-about__door');
        const aboutTl = gsap.timeline({
            scrollTrigger: {
                trigger: aboutSection,
                start: startAnime,
                end: "center center",
                scrub: scrub,
                markers:false
            }
        });
        aboutTl.to(aboutDoor, { duration: 1, rotationY: -90 });
    }
}

export default SectionLandingAbout;